export enum FieldType {
  STRING = "string",
  NUMBER = "number",
  BOOLEAN = "boolean",
  CURRENCY = "currency",
  DAYS = "days",
  COUNT = "count",
  HOURS = "hours",
  MINUTES = "minutes",
  CHARGE = "charge",
}
